/**
 * Knowledge Base Service - Unified API Implementation
 * Clean implementation using the new unified REST API structure
 */

import { repositories } from '../api/createRepositories';

const knowledgebaseRepository = repositories.knowledgebase;

export const knowledgebaseService = {
  getDocuments: async (options = {}) => {
    const response = await knowledgebaseRepository.getDocuments(options);
    return {
      documents: response.documents || [],
      pagination: response.pagination || {},
      total: response.pagination?.total || 0,
    };
  },

  createDocumentFromUrl: async (urlData) => {
    return await knowledgebaseRepository.createDocumentFromUrl(urlData);
  },

  createDocumentFromText: async (textData) => {
    return await knowledgebaseRepository.createDocumentFromText(textData);
  },

  createDocumentFromFile: async (fileData) => {
    return await knowledgebaseRepository.createDocumentFromFile(fileData);
  },

  getRagIndexOverview: async () => {
    const response = await knowledgebaseRepository.getRagIndexOverview();
    return {
      indexes: response.indexes || [],
    };
  },

  getDocumentById: async (documentId) => {
    return await knowledgebaseRepository.getDocumentById(documentId);
  },

  updateDocument: async (documentId, updateData) => {
    return await knowledgebaseRepository.updateDocument(documentId, updateData);
  },

  deleteDocument: async (documentId) => {
    await knowledgebaseRepository.deleteDocument(documentId);
    return { success: true };
  },

  getDocumentRagIndexes: async (documentId) => {
    const response = await knowledgebaseRepository.getDocumentRagIndexes(documentId);
    return {
      indexes: response.indexes || [],
    };
  },

  computeRagIndex: async (documentId, ragConfig = {}) => {
    return await knowledgebaseRepository.computeRagIndex(documentId, ragConfig);
  },

  deleteRagIndex: async (documentId, ragIndexId) => {
    await knowledgebaseRepository.deleteRagIndex(documentId, ragIndexId);
    return { success: true };
  },

  getDependentAgents: async (documentId) => {
    const response = await knowledgebaseRepository.getDependentAgents(documentId);
    return {
      agents: response.agents || [],
    };
  },

  getDocumentContent: async (documentId) => {
    return await knowledgebaseRepository.getDocumentContent(documentId);
  },

  getDocumentChunk: async (documentId, chunkId) => {
    return await knowledgebaseRepository.getDocumentChunk(documentId, chunkId);
  },

  getKnowledgeBaseSize: async (agentId) => {
    return await knowledgebaseRepository.getKnowledgeBaseSize(agentId);
  },

};

export default knowledgebaseService;
